<template>
    <CompassTooltip
        :content="$t.__('utilities.NotificationChip.mark_as_read')"
        placement="bottom-end"
        contentClass="notification-chip-tooltip"
        :arrow="false"
    >
        <div class="chip-container" @click.stop="$emit('clicked')">
            <div class="chip label-chip primary-50-bkg m-auto" />
        </div>
    </CompassTooltip>
</template>
<script>
export default {
    emits: ['clicked'],
};
</script>
<style scoped lang="scss">
@use '~@sellsy/styleguide/src/_variables' as *;

.chip-container {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease-out;
    &:hover {
        background-color: $primary-10;
    }
}
</style>

<style lang="scss">
.notification-chip-tooltip {
    z-index: 2002 !important;
}
</style>
